import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsPermitted } from '../hooks/user';
import { useSelector } from 'react-redux';
import { OrganizationMemberSelectors } from '../store/selectors/organizationMember';

type RoleRouteDescriptor = { [key: string]: string };

interface RouteWithPermissionsProps {
    element: React.ReactElement;
    allowedRoles?: (string | undefined)[];
    roleRedirectTo?: string | RoleRouteDescriptor;
    roleBasedComponents?: { [key: string]: React.ComponentType<any> };
}

const permissionDeniedPanel = (
    <div>
        <h1>Sorry, you do not have access to this part of the application.</h1>
    </div>
);

const RouteWithPermissions: FCWithChildren<RouteWithPermissionsProps> = (props) => {
    const { element, roleBasedComponents, allowedRoles = [undefined], roleRedirectTo } = props;
    const activeMember = useSelector(OrganizationMemberSelectors.getActiveMember);
    const adminMember = useSelector(OrganizationMemberSelectors.getAdminMember);

    const orgRoles = adminMember
        ? adminMember.orgRoles
        : activeMember
          ? activeMember.orgRoles
          : undefined;
    const userRoles = adminMember
        ? adminMember.userRoles
        : activeMember
          ? activeMember.userRoles
          : undefined;
    const isAllowedForOrg = useIsPermitted(allowedRoles);

    if (isAllowedForOrg) {
        if (orgRoles && roleBasedComponents) {
            const Component = roleBasedComponents[orgRoles[0]];
            if (Component) {
                return <Component />;
            }
        }

        return element;
    } else {
        const role = !Array.isArray(orgRoles)
            ? undefined
            : orgRoles.length > 0
              ? orgRoles[0]
              : undefined;

        const userRole = !Array.isArray(userRoles)
            ? undefined
            : userRoles.length > 0
              ? userRoles[0]
              : undefined;
        if (role === undefined || userRole === undefined) return <Navigate to="/login" replace />;
        if (roleRedirectTo === undefined) return <>{permissionDeniedPanel}</>;
        if (typeof roleRedirectTo === 'string') return <Navigate to={roleRedirectTo} replace />;
        else return <Navigate to={roleRedirectTo[role]} replace />;
    }
};

export default RouteWithPermissions;
